import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M967.918 262.144H57.745a36.413 36.413 0 1 1 0-72.827H967.96a36.413 36.413 0 0 1 0 72.827" /><path d="M709.419 203.899h-72.827a123.945 123.945 0 0 0-123.74-123.781 123.945 123.945 0 0 0-123.781 123.78h-72.868c0-108.42 88.187-196.607 196.608-196.607s196.608 88.187 196.608 196.608M334.88 753.664a36.413 36.413 0 0 1-36.454-36.413V469.688a36.413 36.413 0 1 1 72.868 0v247.563a36.413 36.413 0 0 1-36.454 36.413m178.422 0a36.413 36.413 0 0 1-36.414-36.413V469.688a36.413 36.413 0 1 1 72.827 0v247.563a36.413 36.413 0 0 1-36.413 36.413m178.421 0a36.413 36.413 0 0 1-36.454-36.413V469.688a36.413 36.413 0 1 1 72.868 0v247.563a36.413 36.413 0 0 1-36.455 36.413" /><path d="M784.744 990.413H238.502a109.281 109.281 0 0 1-109.2-109.2V218.481h72.827v662.732c0 20.07 16.302 36.373 36.373 36.373h546.242c20.03 0 36.332-16.343 36.332-36.373V218.481h72.827v662.732a109.281 109.281 0 0 1-109.159 109.159" /></svg>

const Trash = React.forwardRef((props, ref) => {
  return (
    <IconBase name="trash" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Trash.displayName = 'IconTrash'

export default Trash
